<template>
  <h1>TanDD Administrator</h1>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>

</style>
